module.exports = __webpack_public_path__ + "img/trial4-2.6e4f1090.png";